import { zManufacturerCommonSchema } from "./manufacturer.common";
// DTO схема для Manufacturer
export const zManufacturerSchemaDto = zManufacturerCommonSchema;
export const zManufacturerSchemaCreateDto = zManufacturerSchemaDto.omit({
    id: true,
});
